import { Chain } from 'viem';

import { NetworkFilter } from '@/components/Filters/NetworkFilter';

import {
  ADVANCED_CLOSED_ORDER_STATUS_FILTER_OPTIONS,
  isAdvancedClosedOrderStatus,
} from '@/constants/advancedOrder';

import { Multiselect } from '@/ui/Multiselect';
import { Select } from '@/ui/Select';

import { timeFilters, TimeFilterValue, type FiltersReducerState } from './reducer';

export const DEFAULT_ORDER_TYPES = ['market', 'limit', 'cross-chain'];

interface FiltersProps {
  /** List of networks to filter the list. */
  networks: Chain[];
  /** Callback function to be called when filters change. */
  onChange: (state: FiltersReducerState) => void;
  /** Current filters state. */
  values: FiltersReducerState;
  showStatus?: boolean;
}

/**
 * Order history filters component.
 */
export const Desktop = ({ networks, values, onChange, showStatus = false }: FiltersProps) => {
  const handleTimeFilterChange = (value: string[]) => {
    const selectedValue = value[0];
    const processedValue = Number.isNaN(Number(selectedValue))
      ? (selectedValue as TimeFilterValue)
      : Number(selectedValue);
    onChange({ ...values, time: processedValue });
  };

  return (
    <div className="hidden tablet:flex justify-between w-full">
      <ul className="flex flex-col tablet:flex-row">
        <li className="mb-1 tablet:mb-0 mr-3">
          <NetworkFilter
            value={values.networks}
            onChange={(networks) => onChange({ ...values, networks })}
            networks={networks.map((network) => network.id)}
          />
        </li>
        <li className="mb-1 tablet:mb-0 mr-3">
          <Multiselect
            items={timeFilters.map(({ value, label }) => ({ value: value.toString(), label }))}
            value={[values.time.toString()]}
            onChange={handleTimeFilterChange}
            defaultValue={['0']}
            multiselect={false}
            label={{ default: 'All time', entity: '' }}
          />
        </li>
        {showStatus && (
          <li className="mb-1 tablet:mb-0 mr-3">
            <Select
              ariaLabel="Advanced order status"
              variant="secondary"
              items={ADVANCED_CLOSED_ORDER_STATUS_FILTER_OPTIONS}
              placeholderText="All statuses"
              selected={values.status ?? 'all'}
              onSelect={(status) =>
                onChange({
                  ...values,
                  status: isAdvancedClosedOrderStatus(status) ? status : undefined,
                })
              }
              align="start"
            />
          </li>
        )}
      </ul>
    </div>
  );
};
